import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AuthService} from "./auth.service";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private datetimeRegex = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z?$/;
  private dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;

  constructor(private auth: AuthService,
              private tokenService: HttpXsrfTokenExtractor) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const xsrftoken = this.tokenService.getToken();
    // console.log(xsrftoken);
    if(this.auth){
      // const token = this.auth.token;
      // if(token){
      //   request = request.clone({
      //     headers: request.headers.set('Authorization', 'Bearer ' + token)
      //   });
      // }
    }

    return next.handle(request);

    // return next.handle(request).pipe(map( (val: HttpEvent<any>) => {
    //   if (val instanceof HttpResponse){
    //     const body = val.body;
    //     this.convertDates(body);
    //   }
    //   return val;
    // }));
  }

  private convertDates(object: Object) {
    if (!object || !(object instanceof Object)) {
      return;
    }

    if (object instanceof Array) {
      for (const item of object) {
        this.convertDates(item);
      }
    }

    for (const key of Object.keys(object)) {
      const value = object[key];

      if (value instanceof Array) {
        for (const item of value) {
          this.convertDates(item);
        }
      }

      if (value instanceof Object) {
        this.convertDates(value);
      }

      if (typeof value === 'string') {
        if(this.datetimeRegex.test(value)){
          object[key] = new Date(value);
        }
        else if(this.dateRegex.test(value)){
          const values = value.split('-');
          object[key] = new Date(parseInt(values[0]), parseInt(values[1])-1, parseInt(values[2]), 0, 0, 0, 0);
        }
      }
    }
  }
}
